import React from 'react';
import css from './Header.scss';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import PropTypes from 'prop-types';
import IconWrapper from 'Components/IconWrapper/IconWrapper';
import cx from 'classnames';

const Header = ({
    val,
    isBack,
    isMainCross,
    handleBack,
    handleCrossClick,
    children,
    hideCross,
    headerCustomCSS = '',
    iconCustomCSS = '',
    headerTextCustomCSS = '',
    primaryIcon = 'back'
}) => {
    return (
        <header className={ cx(css.headingHeader, headerCustomCSS) }>
            <div className={ css.headinHeaderValue }>
                { isBack
                    && <IconWrapper
                        onClick={ handleBack }
                        icon={ primaryIcon }
                        size={ 24 }
                        color="primaryBase"
                        className={ cx(css.backIcon, iconCustomCSS) }
                    />
                }
                <div className={ isBack ? cx(css.backMargin, headerTextCustomCSS) : '' }>
                    { val }
                </div>
            </div>
            {/* eslint-disable-next-line react/jsx-no-bind */}
            { !hideCross && <div onClick={ () => handleCrossClick(isMainCross) }>
                <Icon icon="cross" size={ 15 } color="primaryBase" />
            </div>
            }
            { children }
        </header>
    );
};

Header.propTypes = {
    val: PropTypes.any,
    isBack: PropTypes.bool,
    isMainCross: PropTypes.bool,
    handleBack: PropTypes.func,
    handleCrossClick: PropTypes.func,
    children: PropTypes.any,
    hideCross: PropTypes.any,
    headerCustomCSS: PropTypes.string,
    iconCustomCSS: PropTypes.string,
    headerTextCustomCSS: PropTypes.string,
    primaryIcon: PropTypes.string
};

Header.defaultProps = {
    val: '',
    isBack: false,
    isMainCross: false,
    handleBack: () => {},
    handleCrossClick: () => {}
};

export default Header;
